export default __webpack_public_path__ + "static/media/punti-vendita.fbb9cc2a.svg";